<template>
  <nav
    class="navbar navbar-expand-lg navbar-absolute"
    :class="{ 'bg-white': showMenu, 'navbar-transparent': !showMenu }"
  >
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
        <div
          class="navbar-toggle d-inline"
          :class="{ toggled: $sidebar.showSidebar }"
        ></div>
        <a class="navbar-brand" href="javascript:void(0)"> {{ $route.name }}</a>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        @click="toggleMenu"
        data-toggle="collapse"
        data-target="#navigation"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>
      <div class="collapse navbar-collapse show text-left" v-show="showMenu">
        <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
          <li class="d-none d-lg-block d-xl-block">
            <p class="d-flex align-items-center h-100">
              {{ this.dados.NOME_EMPREGADO }}
            </p>
          </li>
          <drop-down>
            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
              <div class="photo">
                <img
                  v-if="imgRecente"
                  :src="'data:image/png;base64,' + imgRecente"
                  id="vitrine"
                  alt="Profile Photo"
                />
                <img v-else src="@/assets/img/anime3.png" alt="Profile Photo" />
              </div>
              <b class="caret d-none d-lg-block d-xl-block"></b>
              <p class="d-lg-none">
                {{ this.dados.NOME_EMPREGADO }}
              </p>
            </a>
            <ul class="dropdown-menu dropdown-navbar">
              <li class="nav-link">
                <a href="/#/assinaturasPonto" class="nav-item dropdown-item"
                  >Assinatura de Pontos</a
                >
              </li>
              <li class="nav-link">
                <a
                  href="/#/registrarPonto/colaborador"
                  class="nav-item dropdown-item"
                  >Registro de Pontos</a
                >
              </li>
              <li class="nav-link">
                <a href="/#/abono" class="nav-item dropdown-item">Abono</a>
              </li>
              <li class="nav-link">
                <a href="/#/holerite" class="nav-item dropdown-item"
                  >Holerite</a
                >
              </li>

              <li class="dropdown-divider"></li>
              <li class="nav-link" @click="logout()">
                <a href="javascript:void(0)" class="nav-item dropdown-item"
                  >Sair</a
                >
              </li>
            </ul>
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import DropDown from "@/components/Dropdown.vue";
import SidebarToggleButton from "./SidebarToggleButton.vue";

export default {
  components: {
    DropDown,
    SidebarToggleButton
  },
  data() {
    return {
      searchModalVisible: false,
      searchQuery: "",
      showMenu: false,
      imgRecente: "",
      dados: ""
    };
  },
  mounted() {
    this.carregarFotoF();
    if (document.body.classList != "sidebar-mini") {
      document.body.classList.toggle("sidebar-mini");
    }
  },
  methods: {
    carregarDados() {
      this.dados = JSON.parse(this.$session.get("dados"));
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    router(param) {
      this.$router.push(param);
    },

    carregarFotoF() {
      let th = this;
      let jsonn = new FormData();
      jsonn.append("nrCpf", this.dados.CPF_EMPREGADO);

      this.axios
        .post(
          `${process.env.VUE_APP_API_ADDRESS_REC_FACIAL}/getFotoRecente`,
          jsonn
        )
        .then(response => {
          th.imgRecente = response.data.ImagemRecente;
        })
        .finally(() => {})
        .catch(() => {});
    },

    logout() {
      if (confirm("deseja sair?")) {
        this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie));

        this.$session.clear("w_");
        this.$session.clear("dados");
        this.$session.clear("facial");

        this.$router.push("/login");
      } else {
        //console.log("não sair");
      }
    }
  },
  created() {
    this.carregarDados();
  },
  computed: {
    isRTL() {
      return this.$rtl.isRTL;
    }
  }
};
</script>
<style></style>
